import axios from "axios";
import { authHeaders } from "./apiToken";

export interface Payload {
  [key: string]: any;
}

const API = async (payload: Payload) => {
  const url = "https://process-api-01.azure-api.net/hub/manual/paths/invoke";

  try {
    const config = { headers: await authHeaders() };

    const response = await axios.post(url, payload, config);

    return response.data;
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
};

export default API;
